const range = number => [...Array(number).keys()]

export default range
